// extracted by mini-css-extract-plugin
export default {"file-type-icon":"w3WXduzmjU5OBNcgoNh8","extension":"CKuvaAIBbCzpWAg8d2wx","extension-missing":"GBLuGdP5f8ONB5Xwy5XD CKuvaAIBbCzpWAg8d2wx","architecture":"Fzk8q28TZ4SJzspHxm0T"};